import { Components } from '@mui/material/styles/components';
import { Theme } from '@mui/material/styles/createTheme';

// todo: check styles
//       the ones that change color should only apply to 'standard' variant
//       those which modify shape/size/border should apply to every variant
export const ThemeMuiToggleButtonGroup: Components<Omit<Theme, 'components'>>['MuiToggleButtonGroup'] = {
  styleOverrides: {
    root: {
      backgroundColor: '#EDF3F9',
      padding: '4px',
      border: 0,
    },
    firstButton: {
      border: 0,
      margin: 0,
      borderRadius: '4px'
    },
    middleButton: {
      border: 0,
      margin: 0,
      borderRadius: '4px',
    },
    lastButton: {
      border: 0,
      margin: 0,
      borderRadius: '4px'
    }
  },
};

// todo: check styles
//       the ones that change color should only apply to 'standard' variant
//       those which modify shape/size/border should apply to every variant
export const ThemeMuiToggleButton: Components<Omit<Theme, 'components'>>['MuiToggleButton'] = {
  styleOverrides: {
    root: {
      border: 0,
      padding: '6px 10px',
      textTransform: 'none',
      '&.Mui-selected': {
        border: '0',
        borderRadius: '4px',
        backgroundColor: '#fff',
        padding: '6px 10px'
      },
    },
  },
};
